import { Component, OnInit, Inject, Input, ViewChild, AfterViewInit, EventEmitter, DOCUMENT } from '@angular/core';
import {
  BusinessProcessStatelessDataContext, BusinessProcessStatelessInstanceViewModel, BusinessProcessStatelessQueryResult,
  BusinessProcessStateLessDefinitionDetail, DynamicQueryResult, BusinessProcessStateLessActionDetail,
  Action, ItemSource, BusinessProcessStatelessUserAction, SwitchPortal, BusinessProcessStatelessDependantDataItemSource, totalItems
} from '../WorkflowDashBoard/WorkflowDashBoard.model';

import { GenericService } from '../common/common.service';
import { environment } from '../environments/environment';
import { DatePipe } from '@angular/common';
import { DxDataGridComponent } from 'devextreme-angular';
import { ConfirmationComponent, ConfirmationType } from '../common/Controls/Confirmation/confirmation.component';
import { UtilityService } from '../common/utility.service';
import SelectBox, { Properties } from "devextreme/ui/select_box";
import { Constants } from '../common/constants';
import { DatePickerService } from '../common/date-picker/date-picker.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { ActivatedRoute } from '@angular/router';



@Component({
    selector: 'app-statelessworkflow',
    templateUrl: './StatelessWorkflow.component.html',
    styleUrls: ['./StatelessWorkflow.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
export class StatelessWorkflowComponent implements OnInit {

  onInitialized = new EventEmitter<StatelessWorkflowComponent>();

  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public __oBusinessProcessStatelessDataContext: BusinessProcessStatelessDataContext[] = [];
  public __oStatelesscolumns: Array<any> = [];
  public __oStatelessGridMasterDetailOption: any;
  public __oStatelessGridSelectedKeys: number[] = [];
  public __oStatelessGridColumnDetail: any = null;
  public __oBusinessProcessStatelessQueryResult: BusinessProcessStatelessQueryResult[] = [];
  public __oStatelessColumnDetail: string[] = [];
  public __oBusinessProcessStateLessDefinitionDetails: BusinessProcessStateLessDefinitionDetail[] = [];
  public __oMultiSelectControlColumnIndex: number[] = [];
  public __oBusinessProcessStateLessActionDetail: BusinessProcessStateLessActionDetail[] = [];
  public __oBusinessProcessStateLessCommonAction: Action[] = [];
  public __oStatelessGridFilters: any = null;
  public __oStatelessGridSortings: any[] = [];
  public __oBusinessProcessStateLessActionExecuteWebUrls: string[] = [];
  public __bStateLessGridAddRowButtonVisible: boolean = false;
  __iWfBusinessProcessDefinitionId: number = 0;
  public __bIsLoadingVisible: boolean = false;
  @ViewChild("statelessWorkflowTabGrid") __oDataGrid: DxDataGridComponent;
  public __oSwitchPortal: SwitchPortal = null;
  public __ototalItems: totalItems[] = [];
  hideDashboardMenu: boolean = false;
  //input values
  @Input() __bIsOpenedThroughURL: boolean = false;
  @Input() __sIsFilterApplied: string = '';
  @Input() __sParam: string = '';
  @Input() __sBusinessProcessName: string = '';
  @Input() __bIsChild: boolean = false;
  public __lButtonItems: any[] = [];
  @ViewChild(ConfirmationComponent) __oConfirmationComponent: ConfirmationComponent;



  //Constructor
  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public datePipe: DatePipe, public __oUtilityService: UtilityService, public datePickerService: DatePickerService, private route: ActivatedRoute) {

    this.__oStatelessGridMasterDetailOption = { enabled: true, template: 'detail' }

    this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetSwitchPortal").then((Data) => {

      if (Data != null) {
        this.__oSwitchPortal = Data[0];
      }

    });


    this.__lButtonItems = [
      { icon: "xlsxfile", value: "Export all data", name: "Export all data" },
      { icon: "exportselected", value: "Export selected rows", name: "Export selected rows" }
    ];

  }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);
     this.route.queryParamMap.subscribe(params => {
      this.hideDashboardMenu = params.get('hideDashboardMenu') === 'true';
    });
  }

  // fires on post view renders
  ngAfterViewInit() {
  }
  //Get a base web api url to make a call(post/put/get/delete)
 

  public __bSLDropDownOpened: boolean = false;

  get gridBoxValue(): boolean {
    return this.__bSLDropDownOpened;
  }

  set gridBoxValue(value: boolean) {
    this.__bSLDropDownOpened = value;
    if (this.__bSLDropDownOpened == false) {
      if (this.__oMultiSelectControlColumnIndex.length > 0 /*&& this.__oMultiSelectControlColumnIndex.indexOf(e.columnIndex) >= 0*/) {

        for (var rownumber of this.__oStatelessGridSelectedKeys) {
          let oBusinessProcessStatelessDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == rownumber);

          for (var oMultiSelectColumnIndex of this.__oMultiSelectControlColumnIndex) {

            let oArraySelectedItems = oBusinessProcessStatelessDataContext.MultiSelectedItems[oMultiSelectColumnIndex];

            if (oArraySelectedItems != null && oArraySelectedItems != undefined) {

              oBusinessProcessStatelessDataContext.DataValue[oMultiSelectColumnIndex] = oArraySelectedItems.join(',');
            }
          }
        }
      }
    }
  }

  //Populate a stateless grid 
  RefreshGrid() {
    this.__oStatelesscolumns = [];
    this.__oBusinessProcessStateLessDefinitionDetails = [];
    this.__oBusinessProcessStatelessQueryResult = [];
    this.__oBusinessProcessStatelessDataContext = [];
    this.__oMultiSelectControlColumnIndex = [];
    this.__oStatelessColumnDetail = [];
    this.__oStatelessGridSelectedKeys = [];
    this.__oBusinessProcessStateLessActionDetail = [];
    this.__oBusinessProcessStateLessCommonAction = [];
    this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
    this.__bStateLessGridAddRowButtonVisible = false;
    this.__ototalItems = [];

    //if (this.__oDataGrid != null && this.__oDataGrid != undefined) {
    //  this.__oDataGrid.instance.clearFilter();
    //  this.__oDataGrid.instance.clearSorting();
    //}

    if (!this.__oUtilityService.IsNullOrUndefined(this.__oDataGrid)) {
      this.__oDataGrid.instance.collapseAll(-1);
    }

    this.__bIsLoadingVisible = true;
    this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessDefinitionDetail/" + this.__iWfBusinessProcessDefinitionId)
      .subscribe((Data) => {
        if (Data != null && Data.length > 0) {
          this.__oBusinessProcessStateLessDefinitionDetails = Data;

          if (this.__oBusinessProcessStateLessDefinitionDetails != null && this.__oBusinessProcessStateLessDefinitionDetails != undefined && this.__oBusinessProcessStateLessDefinitionDetails.length > 0 && this.__oBusinessProcessStateLessDefinitionDetails[0].IsAddRowEnabled == 1) {
            this.__bStateLessGridAddRowButtonVisible = true;
          }

          this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStateLessDataItemSource/" + this.__iWfBusinessProcessDefinitionId).subscribe((Data) => {

            if (Data != null) {

              for (var oStatelessDefinitionWithItemsource of Data) {
                let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = this.__oBusinessProcessStateLessDefinitionDetails
                  .find(x => x.lBusinessProcessStateLessDefinitionDetailId == oStatelessDefinitionWithItemsource.lBusinessProcessStateLessDefinitionDetailId);

                oBusinessProcessStateLessDefinitionDetail.ItemSource = oStatelessDefinitionWithItemsource.ItemSource;
                /*start FB - 25709 - charles - 04/02/2021*/
                //this.__bIsLoadingVisible = false;
              }

            }
            else {
              //this.__bIsLoadingVisible = false;
            }

            if (this.__bIsOpenedThroughURL && this.__sIsFilterApplied != null && this.__sIsFilterApplied.toLowerCase() == 'true') {
              this.__bIsLoadingVisible = true;
              this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDynamicWorkflowQueryResultWithFilter/" + this.__iWfBusinessProcessDefinitionId + "/" + this.URLEncode(this.__sParam)).subscribe((Data) => {

                if (Data != null) {

                  let oBusinessProcessStatelessInstanceViewModel: any = Data;

                  this.PopulateDynamicGrid(oBusinessProcessStatelessInstanceViewModel);
                  //this.__bIsLoadingVisible = false;

                }
                else {
                  this.__bIsLoadingVisible = false;
                }

              });
            }
            else {
              this.__bIsLoadingVisible = true;
              this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetDynamicWorkflowQueryResult/" + this.__iWfBusinessProcessDefinitionId).subscribe((Data) => {

                if (Data != null) {

                  let oBusinessProcessStatelessInstanceViewModel: any = Data;

                  this.PopulateDynamicGrid(oBusinessProcessStatelessInstanceViewModel);
                  if (this.hideDashboardMenu) {
                    $('.pCollapsable').css({ 'top': '4.5rem' });
                    $('#statelessWorkflowTabGrid').css({ 'height': 'calc(100vh - 15rem)' });
                  }
                  //this.__bIsLoadingVisible = false;
                }
                else {
                  this.__bIsLoadingVisible = false;
                }

              });
            }
          });
        }
        else {
          this.__bIsLoadingVisible = false;
        }
        /*start FB - 17685 - vidya - 08/06/2020*/
        //this.__bIsLoadingVisible = false;
        /*End FB - 17685 - vidya - 08/06/2020*/
      });
  }

  //Populate a grid context & its columns through query
  PopulateDynamicGrid(e: BusinessProcessStatelessInstanceViewModel) {
    let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = e;
    this.__oStatelessGridColumnDetail = null;
    //if (oBusinessProcessStatelessInstanceViewModel.IsMDX == "true")
    //{
    //  this.PopulateDynamicGridMDX(oBusinessProcessStatelessInstanceViewModel);
    //  return;
    //}

    try {
      this.__oStatelessGridColumnDetail = JSON.parse(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);

    }
    catch {
      console.log(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
    }

    if (oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource != null) {
      this.__oBusinessProcessStatelessQueryResult = [];


      try {
        var oDynamicColumnDetail = JSON.parse(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
        var oDynamicQueryResult = JSON.parse(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);

      }
      catch {
        console.log(oBusinessProcessStatelessInstanceViewModel.ColumnDetail);
      }


      // Generating grid columns

      let iColumnIndex: number = 2;
      let oCurrentComponant = this;

      this.__oStatelessColumnDetail.push('SelectionCheckBox');
      this.__oStatelessColumnDetail.push('MasterDetail');

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {


        this.__oStatelessColumnDetail.push(oSDD.ColumnName);
        

        if (oSDD.IsInput == 1) {
          if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateDate',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              dataType: 'date',
              format: 'dd-MMM-yyyy'
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateCheckBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            this.__oMultiSelectControlColumnIndex.push(iColumnIndex);

            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiSelect',
              //calculateCellValue: function (rowData) {
              //  let column = this as any;
              //  return that.calculateStatelessGridMultiselectCellValue(rowData, column);
              //},
              //cellTemplate: 'cellTemplateMultiSelect',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              //setCellValue: function (rowData: any, value: any, currentRow: any) {
              //  console.log(rowData);

              //}
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Combo Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateComboBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Auto Complete Box Sql') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAutoComplete',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAmount',
              //cellTemplate: 'cellTemplateAmount',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              //allowEditing: true,
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              format: oSDD.FormatString,
              dataType: 'number'
            })
            //Add IsSummary flaag need to be added

            if (oSDD.IsSummary == 1) {
              let oTotalItem: totalItems = { column: "DataValue[" + iColumnIndex + "]", summaryType: "sum", valueFormat: "fixedPoint", precision: "0" };
              this.__ototalItems.push(oTotalItem);
            }
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Reference Data') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateDataReferenceReadOnly',
              cellTemplate: 'cellTemplateDataReferenceReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              allowEditing: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'URL') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateDataReferenceReadOnly',
              cellTemplate: 'cellTemplateURLReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              allowEditing: false
            })
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
            //this.__oStatelesscolumns.push({
            //  dataField: "DataValue[" + iColumnIndex + "]",
            //  caption: oSDD.ColumnHeader,
            //  //editCellTemplate: 'cellTemplateMultilineReadOnly',
            //  //cellTemplate: 'cellTemplateMultilineReadOnly',
            //  width: oSDD.Width,
            //  //fixed: true,
            //  //sortOrder: 'asc',
            //  allowSorting: true,
            //  allowFiltering: true,
            //  allowReordering: false,
            //  allowHiding: false,
            //  showInColumnChooser: false
            //})
          }
        }
        else {
          if (oSDD.lwfBusinessProcessStatelessInputTypeId != null) {
            if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateDateReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                dataType: 'date',
                format: 'dd-MMM-yyyy'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateCheckBoxReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateAmountReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                format: oSDD.FormatString,
                dataType: 'number'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Reference Data') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateDataReferenceReadOnly',
                cellTemplate: 'cellTemplateDataReferenceReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false

              })
            }
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate:'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              allowEditing: false
            })
          }
        }

        iColumnIndex += 1;

      }

      // Generating data context for grid

      let sXMLResult: string = oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource;

      //Start Siju 24987
      sXMLResult = sXMLResult.replace('<NewDataSet />', '');
      sXMLResult = sXMLResult.replace('<NewDataSet/>', '');
      //End Siju 24987

      if (sXMLResult != null && sXMLResult != undefined) {
        sXMLResult = sXMLResult.replace(/_x0020_/g, ' ');
      }

      let iRowCount: number = 1;
      let iDataTableStartIndex: number = 0;
      let iDataTableLastIndex: number = 0;
      let sData: string = "";
      let sColumnData: string = "";
      let iColumnStartIndex: number = 0;
      let iColumnLastIndex: number = 0;
      let sColumnValue: string = "";
      let sValue: string = "";

      while (sXMLResult.trim() != '') {
        iDataTableStartIndex = sXMLResult.indexOf("<Datatable1>");
        iDataTableLastIndex = sXMLResult.indexOf("</Datatable1>");

        sData = sXMLResult.substring(iDataTableStartIndex, iDataTableLastIndex + 13);

        sColumnData = sData.replace(/&amp;/g, '&').replace("<Datatable1>", "").replace("</Datatable1>", "").replace(/&gt;/g, '>').replace(/&lt;/g, '<');

        let oBusinessProcessStatelessQueryResult = new BusinessProcessStatelessQueryResult();
        oBusinessProcessStatelessQueryResult.RowNumber = iRowCount;
        oBusinessProcessStatelessQueryResult.QueryResult = [];

        for (var oDCD of oDynamicColumnDetail) {
          iColumnStartIndex = sColumnData.indexOf("<" + oDCD.ColumnName + ">");

          if (iColumnStartIndex >= 0) {
            iColumnLastIndex = sColumnData.indexOf("</" + oDCD.ColumnName + ">");

            sColumnValue = sColumnData.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oDCD.ColumnName + ">").length);

            sValue = sColumnValue.replace("<" + oDCD.ColumnName + ">", "").replace("</" + oDCD.ColumnName + ">", "");

            sColumnData = sColumnData.replace(sColumnValue, "");


          }
          else {
            sValue = "";
            if (sColumnData.indexOf("<" + oDCD.ColumnName + " />") >= 0 || sColumnData.indexOf("<" + oDCD.ColumnName + "/>") >= 0) {
              sColumnData = sColumnData.replace("<" + oDCD.ColumnName + "/>", "").replace("<" + oDCD.ColumnName + " />", "");
            }
          }

          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oDCD.ColumnName;
          oDynamicQueryResult.ColumnType = oDCD.ColumnType;
          oDynamicQueryResult.DataValue = sValue;
          oBusinessProcessStatelessQueryResult.QueryResult.push(oDynamicQueryResult);
        }

        sXMLResult = sXMLResult.replace(sData, '');
        this.__oBusinessProcessStatelessQueryResult.push(oBusinessProcessStatelessQueryResult);

        var oDC = oBusinessProcessStatelessQueryResult;

        let oDataCntext = new BusinessProcessStatelessDataContext();

        oDataCntext.RowNumber = oDC.RowNumber;
        oDataCntext.QueryResult = oDC.QueryResult;

        oDataCntext.DataValue = [];
        oDataCntext.ItemSource = [];
        oDataCntext.MultiSelectedItems = [];
        oDataCntext.IsMultiSelectComboBox = [];
        oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
        oDataCntext.Opened = [];
        oDataCntext.NumberFormat = [];
        oDataCntext.MinNum = [];
        oDataCntext.MaxNum = [];
        oDataCntext.TextSize = [];
        oDataCntext.DataTypeParameter = [];

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.IsMultiSelectComboBox.push(false);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);
        oDataCntext.DataTypeParameter.push('');

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.IsMultiSelectComboBox.push(false);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);
        oDataCntext.DataTypeParameter.push('');

        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          // Adding Datavalue                        

          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oDataCntext.DataValue.push(bValue);

          } else if (oColumn.ColumnType.includes('SqlDateTime')) {
            let sValue: string = oColumn.DataValue;
            if (!sValue) {
              oDataCntext.DataValue.push(null);
            } else {
              oDataCntext.DataValue.push(sValue);
            }
          }
          else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {
            let iValue: number = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              let bValue: boolean = false;

              if (Number(iValue) == 1) {
                bValue = true;
              }

              oDataCntext.DataValue.push(bValue);

            }
            else {
              oDataCntext.DataValue.push(Number(iValue));
            }

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              if (oColumnValue != null && oColumnValue != '') {
                let sValue: string = oColumn.DataValue;
                let bValue: boolean = false;

                if (sValue.toLowerCase() == 'true' || sValue == '1') {
                  bValue = true;
                }

                oDataCntext.DataValue.push(bValue);
              }
              else {
                let bValue: boolean = false;
                oDataCntext.DataValue.push(bValue);
              }
            }
            else {

              if (oColumnValue != null && oColumnValue != '') {
                oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g, '\\');
                oDataCntext.DataValue.push(oColumnValue);
              }
              else {
                let oEmptyValue = '';
                oDataCntext.DataValue.push(oEmptyValue);
              }
            }
          }

          // Adding Itemsource

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {

              console.log(oSDD.ItemSource);
            }

            /*Start FB 12994 - Vidya 25/11/2020*/
            for (let i = 0; i < oIS.length; i++) {
              oIS[i].DisplayMember = oIS[i].DisplayMember.replace(/DooobleQuote/g, '"').replace(/BaccckSlash/g, '\\');
            }
            /*End FB 12994 - Vidya 25/11/2020*/

            oDataCntext.ItemSource.push(oIS);
          }
          else {

            let oItemSource = [];
            oDataCntext.ItemSource.push(oItemSource);
          }


          //Adding multiselected items
          let oMultiSelectedKeys = [];
          oColumn.DataValue ? (oMultiSelectedKeys = oColumn.DataValue.split(",")) : (oMultiSelectedKeys = []);
          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

          if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {
            oDataCntext.IsMultiSelectComboBox.push(true);
          }
          else {
            oDataCntext.IsMultiSelectComboBox.push(false);
          }


          //Adding opened boolean value

          oDataCntext.Opened.push(false);

          // Adding number format , min , max , Text size

          oDataCntext.NumberFormat.push(oSDD.FormatString);
          oDataCntext.MinNum.push(oSDD.Min);
          oDataCntext.MaxNum.push(oSDD.Max);
          oDataCntext.TextSize.push(oSDD.TextSize);

          //Adding a dataType parameter
          oDataCntext.DataTypeParameter.push(oSDD.DataTypeParameter);

        }


        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

          oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {
              console.log(oSDD.ItemSource);
            }
            oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
          }


          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

          }
          if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') 
            || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') 
            || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') 
            || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')
            || oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
            let iValue: number = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              let bValue: boolean = false;

              if (Number(iValue) == 1) {
                bValue = true;
              }

              oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

            }
            else if (!this.__oUtilityService.IsNullOrEmpty(oColumn.DataValue)) {
              oBusinessProcessStateLessDefinitionDetail.DataValue = Number(iValue);
            }
            else if(!this.__oUtilityService.IsNullOrUndefined(oColumn.DataValue))  { oBusinessProcessStateLessDefinitionDetail.DataValue = oColumn.DataValue }

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              if (oColumnValue != null && oColumnValue != '') {
                let sValue: string = oColumn.DataValue;
                let bValue: boolean = false;

                if (sValue.toLowerCase() == 'true' || sValue == '1') {
                  bValue = true;
                }

                oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;
              }
              else {
                let bValue: boolean = false;
                oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;
              }
            }
            else {

              if (oColumnValue != null && oColumnValue != '')
                oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

              oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
            }
          }

          oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
          oBusinessProcessStateLessDefinitionDetail.Opened = false;

          if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
            oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
          }


          oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

        }



        this.__oBusinessProcessStatelessDataContext.push(oDataCntext);

        iRowCount += 1;
      }
    }

    this.__bIsLoadingVisible = true;
    this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessActionDetail/" + this.__iWfBusinessProcessDefinitionId).subscribe((Data) => {

      if (Data != null) {

        this.__oBusinessProcessStateLessActionDetail = Data;

        let oStatelessAction: Action[] = [];

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
          if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oAction = new Action();
            oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            oAction.Width = oAction.Name.length * 8;

            if (oAction.Width < 125)
              oAction.Width = 125;

            oStatelessAction.push(oAction);
          }
        }

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 1)) {
          if (this.__oBusinessProcessStateLessCommonAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oCommonAction = new Action();
            oCommonAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oCommonAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            oCommonAction.Width = oCommonAction.Name.length * 7;

            if (oCommonAction.Width < 125)
              oCommonAction.Width = 125;

            this.__oBusinessProcessStateLessCommonAction.push(oCommonAction);
          }
        }

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

          oBusinessProcessStatelessDataContext.Actions = oStatelessAction;

        }

        let oActionColumnWidth: number = 100;

        if (oStatelessAction.length > 0) {

          for (var oActionWidth of oStatelessAction) {
            oActionColumnWidth = oActionColumnWidth + oActionWidth.Width;
          }

          //oActionColumnWidth = oStatelessAction.length * 150;
        }

        this.__oStatelesscolumns.push({
          cellTemplate: 'cellTemplate',
          caption: '',
          width: oActionColumnWidth,
          allowHiding: false,
          showInColumnChooser: false,
          allowEditing: true
        });
        this.__bIsLoadingVisible = false;
      }
      else {
        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

        }
        this.__bIsLoadingVisible = false;
      }
    });

    // Ensure all columns' header filter popups show all values from the full dataset
    for (var oColumnOptions of this.__oStatelesscolumns) {
      if (oColumnOptions.dataField) {
        oColumnOptions.headerFilter = {
          dataSource: function (options) {
            options.dataSource.filter = null;
          }
        };
      }
    }

    if (this.__oStatelessGridFilters != null && this.__oStatelessGridFilters != undefined) {
      for (var oColumnOptions of this.__oStatelesscolumns) {
        let oColumn = this.__oStatelessGridFilters.find(x => x.caption == oColumnOptions.caption);
        if (oColumn != null) {
          if (oColumn.filterValue !== undefined && oColumn.filterValue !== null && oColumn.filterValue !== '') {
            oColumnOptions.filterValue = oColumn.filterValue;
            if (oColumn.selectedFilterOperation !== undefined) {
              oColumnOptions.selectedFilterOperation = oColumn.selectedFilterOperation;
            }
          }
          if (oColumn.filterValues !== undefined && oColumn.filterValues !== null && oColumn.filterValues.length > 0) {
            oColumnOptions.filterValues = oColumn.filterValues;
            oColumnOptions.filterType = oColumn.filterType || 'include';
          }
        }
      }
      this.__oStatelessGridFilters = null;
    }

    if (this.__oStatelessGridSortings != null && this.__oStatelessGridSortings != undefined && this.__oStatelesscolumns != null && this.__oStatelesscolumns != undefined) {

      for (var oColumnOptions of this.__oStatelesscolumns) {
        let oColumn = this.__oStatelessGridSortings.find(x => x.caption == oColumnOptions.caption);

        if (oColumn != null) {
          if (oColumn.sortOrder != undefined) {
            oColumnOptions.sortOrder = oColumn.sortOrder;
          }
        }
      }

      this.__oStatelessGridSortings = null;
    }

    //this.__bIsLoadingVisible = false;
  }

  //Populate a grid context & its columns through MDX
  PopulateDynamicGridMDX(e: BusinessProcessStatelessInstanceViewModel) {
    let oBusinessProcessStatelessInstanceViewModel: BusinessProcessStatelessInstanceViewModel = e;

    if (oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource != null) {
      this.__oBusinessProcessStatelessQueryResult = [];


      try {
        var oDynamicQueryResult = JSON.parse(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);
      }
      catch {
        console.log(oBusinessProcessStatelessInstanceViewModel.DynamicInstanceDataSource);
      }




      // Generating grid columns

      let iColumnIndex: number = 2;
      let oCurrentComponant = this;

      this.__oStatelessColumnDetail.push('SelectionCheckBox');
      this.__oStatelessColumnDetail.push('MasterDetail');

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {

        this.__oStatelessColumnDetail.push(oSDD.ColumnName);

        if (oSDD.IsInput == 1) {
          if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateDate',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              dataType: 'date',
              format: 'dd-MMM-yyyy'
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateCheckBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            this.__oMultiSelectControlColumnIndex.push(iColumnIndex);

            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateMultiSelect',
              //calculateCellValue: function (rowData) {
              //  let column = this as any;
              //  return that.calculateStatelessGridMultiselectCellValue(rowData, column);
              //},
              //cellTemplate: 'cellTemplateMultiSelect',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              //setCellValue: function (rowData: any, value: any, currentRow: any) {
              //  console.log(rowData);

              //}
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Combo Box') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateComboBox',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Auto Complete Box Sql') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAutoComplete',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
          else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              editCellTemplate: 'cellTemplateAmount',
              //cellTemplate: 'cellTemplateAmount',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              //allowEditing: true,
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false,
              format: "#,##0.00",
              dataType: 'number'
            })
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateMultilineReadOnly',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
        }
        else {
          if (oSDD.lwfBusinessProcessStatelessInputTypeId != null) {
            if (oSDD.wfBusinessProcessStatelessInputType == 'Multiline Text Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Date') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateDateReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                dataType: 'date',
                format: 'dd-MMM-yyyy'
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateCheckBoxReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false
              })
            }
            else if (oSDD.wfBusinessProcessStatelessInputType == 'Amount') {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate:'cellTemplateMultiline',
                cellTemplate: 'cellTemplateAmountReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: false,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false,
                format: "#,##0.##",
                dataType: 'number'
              })
            }
            else {
              this.__oStatelesscolumns.push({
                dataField: "DataValue[" + iColumnIndex + "]",
                caption: oSDD.ColumnHeader,
                //editCellTemplate: 'cellTemplateMultiline',
                //cellTemplate: 'cellTemplateMultilineReadOnly',
                width: oSDD.Width,
                //fixed: true,
                //sortOrder: 'asc',
                allowSorting: true,
                allowFiltering: true,
                allowReordering: false,
                allowHiding: false,
                showInColumnChooser: false,
                allowEditing: false

              })
            }
          }
          else {
            this.__oStatelesscolumns.push({
              dataField: "DataValue[" + iColumnIndex + "]",
              caption: oSDD.ColumnHeader,
              //editCellTemplate: 'cellTemplateMultiline',
              //cellTemplate: 'cellTemplateMultilineReadOnly',
              width: oSDD.Width,
              //fixed: true,
              //sortOrder: 'asc',
              allowSorting: true,
              allowFiltering: true,
              allowReordering: false,
              allowHiding: false,
              showInColumnChooser: false
            })
          }
        }

        iColumnIndex += 1;
      }


      // Generating data context for grid
      for (var oDQR of oDynamicQueryResult) {
        let oBusinessProcessStatelessQueryResult = new BusinessProcessStatelessQueryResult();

        let oRowNumber = oDQR[0];
        let oResult = oDQR[1];

        oBusinessProcessStatelessQueryResult.RowNumber = oRowNumber.RowNumber;
        oBusinessProcessStatelessQueryResult.QueryResult = [];

        for (var oQR of oResult) {
          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oQR.ColumnName;
          oDynamicQueryResult.ColumnType = oQR.ColumnType;

          oDynamicQueryResult.DataValue = oQR.DataValue;

          oBusinessProcessStatelessQueryResult.QueryResult.push(oDynamicQueryResult);
        }

        this.__oBusinessProcessStatelessQueryResult.push(oBusinessProcessStatelessQueryResult);

        var oDC = oBusinessProcessStatelessQueryResult;

        let oDataCntext = new BusinessProcessStatelessDataContext();

        oDataCntext.RowNumber = oDC.RowNumber;
        oDataCntext.QueryResult = oDC.QueryResult;

        oDataCntext.DataValue = [];
        oDataCntext.ItemSource = [];
        oDataCntext.MultiSelectedItems = [];
        oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
        oDataCntext.Opened = [];
        oDataCntext.NumberFormat = [];
        oDataCntext.MinNum = [];
        oDataCntext.MaxNum = [];
        oDataCntext.TextSize = [];

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.IsMultiSelectComboBox.push(false);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);

        oDataCntext.DataValue.push('');
        oDataCntext.ItemSource.push([]);
        oDataCntext.MultiSelectedItems.push([]);
        oDataCntext.IsMultiSelectComboBox.push(false);
        oDataCntext.Opened.push(false);
        oDataCntext.NumberFormat.push('#,##0.##');
        oDataCntext.MinNum.push(0);
        oDataCntext.MaxNum.push(99);
        oDataCntext.TextSize.push(5000);

        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          // Adding Datavalue                        

          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oDataCntext.DataValue.push(bValue);

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oColumnValue != null && oColumnValue != '') {
              oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g, '\\');
              oDataCntext.DataValue.push(oColumnValue);
            }
            else {
              let oEmptyValue = '';
              oDataCntext.DataValue.push(oEmptyValue);
            }
          }

          // Adding Itemsource
          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {

              console.log(oSDD.ItemSource);
            }

            oDataCntext.ItemSource.push(oIS);
          }
          else {

            let oItemSource = [];
            oDataCntext.ItemSource.push(oItemSource);
          }

          //Adding multiselected items
          let oMultiSelectedKeys = [];
          oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

          //Adding opened boolean value
          oDataCntext.Opened.push(false);

          // Adding number format , min , max , Text size
          oDataCntext.NumberFormat.push(oSDD.FormatString);
          oDataCntext.MinNum.push(oSDD.Min);
          oDataCntext.MaxNum.push(oSDD.Max);
          oDataCntext.TextSize.push(oSDD.TextSize);
        }

        for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
          let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

          oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

          if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oSDD.ItemSource);
            }
            catch {
              console.log(oSDD.ItemSource);
            }
            oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
          }


          let oColumn = oDC.QueryResult.find(x => x.ColumnName == oSDD.ColumnName);

          if (oColumn.ColumnType.includes('Boolean')) {
            let sValue: string = oColumn.DataValue;
            let bValue: boolean = sValue.toLowerCase() == 'true' ? true : false
            oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

          }
          else {
            let oColumnValue: string = oColumn.DataValue;

            if (oColumnValue != null && oColumnValue != '')
              oColumnValue = oColumnValue.toString().replace(/DooobleQuote/g, '"');

            oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
          }

          oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
          oBusinessProcessStateLessDefinitionDetail.Opened = false;

          if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
            oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
          }


          oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

        }

        this.__oBusinessProcessStatelessDataContext.push(oDataCntext);
      }
    }


    this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessStateLessActionDetail/" + this.__iWfBusinessProcessDefinitionId).subscribe((Data) => {

      if (Data != null) {

        this.__oBusinessProcessStateLessActionDetail = Data;

        let oStatelessAction: Action[] = [];

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
          if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oAction = new Action();
            oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            oStatelessAction.push(oAction);
          }
        }

        for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 1)) {
          if (this.__oBusinessProcessStateLessCommonAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
            let oCommonAction = new Action();
            oCommonAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
            oCommonAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
            this.__oBusinessProcessStateLessCommonAction.push(oCommonAction);
          }
        }

        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

          oBusinessProcessStatelessDataContext.Actions = oStatelessAction;

        }

        let oActionColumnWidth: number = 100;

        if (oStatelessAction.length > 0) {
          oActionColumnWidth = oStatelessAction.length * 110;
        }

        this.__oStatelesscolumns.push({
          cellTemplate: 'cellTemplate',
          width: oActionColumnWidth,
          allowHiding: false,
          showInColumnChooser: false
        })


      }
      else {
        for (var oBusinessProcessStatelessDataContext of this.__oBusinessProcessStatelessDataContext) {
          oBusinessProcessStatelessDataContext.Actions = [];

        }
        this.__bIsLoadingVisible = false;
      }
    });

    this.__bIsLoadingVisible = false;
  }

  //Stateless grid column value changed
  StatelessGridColumnValueChanged(value: any, e: any, columnIndex: any, IsAmount: any, name?: any) {
    if (name) {
      name[columnIndex] = e.value;
    }

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (!this.__oDataGrid.instance.isRowSelected(e)) {
      this.__oDataGrid.instance.selectRows(e, true);
    }

    if (value != undefined) {
      this.GetStatelessDependantDataItemSource(value, e, columnIndex);
    }
    else {      
      this.GetStatelessDependantDataItemSource('', e, columnIndex);
    }

    if (IsAmount == 1)
      this.__oDataGrid.instance.option("dataSource", this.__oBusinessProcessStatelessDataContext);
  }


  StatelessGridColumnValueChangedACB(e: any, columnIndex: any, event: any) {
    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == e).length == 0)
      this.__oStatelessGridSelectedKeys.push(e);

    if (event.selectedItem.DisplayMember != undefined && event.selectedItem.DisplayMember != null) {
      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e);
      oBusinessProcessStateLessGridDataContext.DataValue[columnIndex] = event.selectedItem.DisplayMember;
      this.GetStatelessDependantDataItemSource(event.selectedItem.DisplayMember, e, columnIndex);
    }

  }

  //Replace all with specified characters as mentioned
  public replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  //URL Encoder
  public URLEncode(str: any) {
    let strToBeReturned = "";
    //strToBeReturned = str.replace(/&/g, '%26');
    if (str != null && str != undefined && str != "") {
      strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F').replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\' '/g, "%20").replace(/\+/g, '%2B');//.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
      //strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F');//.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
    }
    else {
      strToBeReturned = str;
    }
    return strToBeReturned;
    //&#%?/
  }

  //Get data for state less auto complete
  GetDataForStateLessACB(ColumnIndex: any, RowIndex: any, RowNumber: any, element: any) {
    //let self = this;
    //this.__oElement = element;
    let ColumnName = this.__oStatelessColumnDetail[ColumnIndex];
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
      let oItemSource: ItemSource[] = oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex];

      FilterValue = this.replaceAll(FilterValue);

      if (oItemSource != undefined && oItemSource.length > 0) {
        if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
          return;
        }
      }

      let sXMLData: string = this.GetStatelessRowDataXML(oBusinessProcessStatelessDataContext);
      sXMLData = this.replaceAll(sXMLData);      
      sXMLData = sXMLData.replace(/\*/g, 'staaar').replace(/\%/g, 'cln25').replace(/\?/g, 'cln3F').replace(/\#/g, 'cln23');
      this.__oDataGrid.instance.focus(this.__oDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
      this.service.getDataByObservable(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessItemSourceForAutoCompleteBox/" + this.__iWfBusinessProcessDefinitionId.toString() + "/" + ColumnName + "/" + FilterValue + "/" + sXMLData).subscribe((Data) => {

        if (Data != null) {

          let oIS;
          let data: any = Data;

          try {
            if (data) {
              data = data.replace(/\\/g, "BaccckSlash");
              oIS = JSON.parse(data);
              oIS = oIS.map(element => {
                element["DisplayMember"] = this.__oUtilityService.ReplaceOriginalCharacters(element["DisplayMember"]); //.replace(/BaccckSlash/g, "\\").replace("quoootes","\"");
                return element;
              });
            }                         
          }
          catch {
            console.log(Data);
          }
          oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex] = oIS;

          let oItemSource: ItemSource[] = oBusinessProcessStatelessDataContext.ItemSource[ColumnIndex];
          if (oItemSource != undefined && oItemSource.length > 0) { oBusinessProcessStatelessDataContext.Opened[ColumnIndex] = true; }
          this.__oDataGrid.instance.focus(this.__oDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
        }

      });
      
    }
    else {
      this.__oDataGrid.instance.focus(this.__oDataGrid.instance.getCellElement(RowIndex, ColumnIndex));
    }

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(RowNumber);
  }

  //State less auto complete on focus in
  StateLessACBonFocusIn(ColumnIndex: any, RowIndex: any, RowNumber: any, element: any) {
    let ColumnName = this.__oStatelessColumnDetail[ColumnIndex];
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let FilterValue: string = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    if (FilterValue != '' && FilterValue != null && FilterValue != undefined && FilterValue.length > 0) {
      if (element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange) {
        element.element.getElementsByClassName("dx-texteditor-input")[0].setSelectionRange(FilterValue.length, FilterValue.length);
      }
      else if (element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange) {
        var range = element.element.getElementsByClassName("dx-texteditor-input")[0].createTextRange();
        range.collapse(true);
        range.moveEnd('character', FilterValue.length);
        range.moveStart('character', FilterValue.length);
        range.select();
      }
    }
  }

  //Get data for state less detail auto complete box
  GetDataForStateLessDetailACB(RowNumber: any, ColumnName: any) {
    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    if (oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      let BusinessProcessStateLessDefinitionDetail = oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails.find(x => x.ColumnName == ColumnName);

      let FilterValue = BusinessProcessStateLessDefinitionDetail.DataValue;

      if (FilterValue != '' && FilterValue != null && FilterValue != undefined) {
        let oItemSource: ItemSource[] = BusinessProcessStateLessDefinitionDetail.ItemSource;

        FilterValue = this.replaceAll(FilterValue);

        if (oItemSource != undefined && oItemSource.length > 0) {
          if (oItemSource.find(x => x.DisplayMember == FilterValue) != null) {
            return;
          }
        }

        let sXMLData: string = this.GetStatelessRowDataXML(oBusinessProcessStatelessDataContext);
        sXMLData = this.replaceAll(sXMLData);
        sXMLData = sXMLData.replace(/\*/g, 'staaar')

        this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessItemSourceForAutoCompleteBox/" + this.__iWfBusinessProcessDefinitionId.toString() + "/" + ColumnName + "/" + FilterValue + "/" + sXMLData).then((Data) => {

          if (Data != null) {

            let oIS;

            try {
              oIS = JSON.parse(Data);
            }
            catch {
              console.log(Data);
            }
            BusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
            if (BusinessProcessStateLessDefinitionDetail.ItemSource != undefined && BusinessProcessStateLessDefinitionDetail.ItemSource.length > 0) { BusinessProcessStateLessDefinitionDetail.Opened = true; }
          }

        });
      }

    }

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(RowNumber);

  }

  //On key press on number box inside a grid row
  onKeyPressNumberBoxSLGrid(e: any, RowNumber: any, ColumnIndex: any, rowIndex: any) {
    if (e.event.key.toString().toUpperCase() == "M" || e.event.key.toString().toUpperCase() == "B" || e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "H" || e.event.key.toString().toUpperCase() == "T") {
      this.__oDataGrid.instance.focus(this.__oDataGrid.instance.getCellElement(rowIndex, ColumnIndex));
      if (e.event.key.toString().toUpperCase() == "M") {
        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
      }
      else if (e.event.key.toString().toUpperCase() == "B") {

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
      }
      else if (e.event.key.toString().toUpperCase() == "K" || e.event.key.toString().toUpperCase() == "T") {

        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
      else if (e.event.key.toString().toUpperCase() == "H") {
        let DataValue = RowNumber.DataValue[ColumnIndex];
        RowNumber.DataValue[ColumnIndex] = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
      }
    }
    if ((e.event.key == 'Delete' || e.event.key == "Backspace")
      && !this.__oUtilityService.IsNullOrUndefined(e.event.target.value) && e.event.target.value.toString() == "0") {
      RowNumber.DataValue[ColumnIndex] = null;

      if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
        this.__oStatelessGridSelectedKeys = [];
      }
      if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber.RowNumber).length == 0)
        this.__oStatelessGridSelectedKeys.push(RowNumber.RowNumber);
    }
  }

  GetStatelessRowDataXML(oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext): string {
    let sXMLData: string = '';

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    return sXMLData;

  };

  //Calculate a cell value
  calculateCellValue(e: any) {
    return 1;
  }

  //Execute a state less user action
  ExecuteStatelessUserAction(e: any, info: any) {
    this.__bIsLoadingVisible = true;
    this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let lwfBusinessProcessStatelessActionId = info.ID;

    let oBusinessProcessStateLessActionDetails: BusinessProcessStateLessActionDetail[] = this.__oBusinessProcessStateLessActionDetail.filter(x => x.lwfBusinessProcessStatelessActionId == lwfBusinessProcessStatelessActionId);

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == e);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString(); //.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    if (oBusinessProcessStateLessGridDataContext.RowStatus == undefined || oBusinessProcessStateLessGridDataContext.RowStatus == null || oBusinessProcessStateLessGridDataContext.RowStatus == '')
      sXMLData += '<RowStatus>Updated</RowStatus>';
    else
      sXMLData += '<RowStatus>' + oBusinessProcessStateLessGridDataContext.RowStatus + '</RowStatus>';

    let oBusinessProcessStatelessUserAction = new BusinessProcessStatelessUserAction();
    oBusinessProcessStatelessUserAction.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessUserAction.lwfBusinessProcessStatelessActionId = lwfBusinessProcessStatelessActionId;
    oBusinessProcessStatelessUserAction.sXMLProcessStatelessData = sXMLData;


    let bServerCallRequired: boolean = false;

    for (let owfBusinessProcessStatelessActionExecute of oBusinessProcessStateLessActionDetails) {
      if (owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != null && owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != '') {
        let sWebUrl: string = '';
        sWebUrl = owfBusinessProcessStatelessActionExecute.OpenFormWebUrl;

        let i: number = 0;

        while (i == 0) {
          let iLastIndexOpenBrace: number = 0;
          let iLastIndexCloseBrace: number = 0;

          iLastIndexOpenBrace = sWebUrl.lastIndexOf("[");
          iLastIndexCloseBrace = sWebUrl.lastIndexOf("]");

          if (iLastIndexOpenBrace > 0 && iLastIndexCloseBrace > 0) {
            if (iLastIndexOpenBrace < iLastIndexCloseBrace) {
              let sReplaceString: string = sWebUrl.substring(iLastIndexOpenBrace, iLastIndexCloseBrace + 1);

              let oReplaceDataValue = oRowData.find(x => x.ColumnName == sReplaceString.replace("[", "").replace("]", ""));

              if (oReplaceDataValue != undefined) {
                if (sWebUrl.startsWith("mailto:")) {
                  sWebUrl = sWebUrl.replace(sReplaceString, oReplaceDataValue.DataValue);
                }
                else {
                  oReplaceDataValue.DataValue = oReplaceDataValue.DataValue.toString().replace(/\[\]/g, "~SqBrac~");
                  sWebUrl = sWebUrl.replace(sReplaceString, this.URLEncode(oReplaceDataValue.DataValue));
                }
              }
            }
          }
          else {
            i = 1;
          }
        }
        sWebUrl = sWebUrl.replace(/~SqBrac~/g, "[]").replace(/\+/g, '%2B');
        this.__oBusinessProcessStateLessActionExecuteWebUrls.push(sWebUrl);



      }
      else {
        bServerCallRequired = true;
      }

    }

    if (bServerCallRequired) {

      this.service.UpdateAllDataByPromise(oBusinessProcessStatelessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostStatelessUserAction").then(
        result => this.OnSuccessSaveStateless(result)
      ).catch(error => this.OnErrorStateless(error))
    }
    else {
      this.__bIsLoadingVisible = false;
      for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
        window.open(oWebUrl, "_blank");
      }
    }
  }

  //Execute a state less user action common method
  ExecuteStatelessUserActionCommon(e: any, info: any) {
    this.__bIsLoadingVisible = true;
    this.__oBusinessProcessStateLessActionExecuteWebUrls = [];
    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let lwfBusinessProcessStatelessActionId = info.ID;

    let oBusinessProcessStateLessActionDetails: BusinessProcessStateLessActionDetail[] = this.__oBusinessProcessStateLessActionDetail.filter(x => x.lwfBusinessProcessStatelessActionId == lwfBusinessProcessStatelessActionId);

    let sXMLData: string = '';

    for (var oSelectedRow of this.__oStatelessGridSelectedKeys) {
      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == oSelectedRow);

      let oRowData: DynamicQueryResult[] = [];

      let iIndex: number = 0;

      // Creating column array with value

      for (var oColumnDetail of this.__oStatelessColumnDetail) {
        let oColumnName = oColumnDetail;
        let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
            oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
          }
        }
        else {
          oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
        }

        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oColumnName;
        oDynamicQueryResult.DataValue = oDataValue;

        oRowData.push(oDynamicQueryResult);

        iIndex += 1;

      }



      if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
        for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

          let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

          let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

          let oDynamicQueryResult = new DynamicQueryResult();
          let oDetailColumnDataValue;

          if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
            if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
              oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
            }
          }
          else {

            if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

              if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
                oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
              }

            }
            else {
              oDetailColumnDataValue = oDetailColumn.DataValue;
            }

          }

          oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
          oDynamicQueryResult.DataValue = oDetailColumnDataValue;

          oRowData.push(oDynamicQueryResult);
        }

      }

      for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
        if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
          let oDynamicQueryResult = new DynamicQueryResult();
          oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

          if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
            let sValue: string = oOtherRowData.DataValue;

            if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
              oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
            }
            else {
              oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
            }
          }
          else {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }

          oRowData.push(oDynamicQueryResult);
        }
      }

      // Creating string stateless row data in XML format

      sXMLData += "<Data>";

      for (var oStatelessRowData of oRowData) {
        sXMLData += "<" + oStatelessRowData.ColumnName + ">";

        if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
          let sValue: string = oStatelessRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            sXMLData += oStatelessRowData.DataValue;
          }
          else {
            sXMLData += sValue.toString(); //.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
          }
        }
        else {
          sXMLData += oStatelessRowData.DataValue;
        }

        sXMLData += "</" + oStatelessRowData.ColumnName + ">";
      }

      if (oBusinessProcessStateLessGridDataContext.RowStatus == undefined || oBusinessProcessStateLessGridDataContext.RowStatus == null || oBusinessProcessStateLessGridDataContext.RowStatus == '')
        sXMLData += '<RowStatus>Updated</RowStatus>';
      else
        sXMLData += '<RowStatus>' + oBusinessProcessStateLessGridDataContext.RowStatus + '</RowStatus>';

      sXMLData += "</Data>";

    }

    sXMLData = "<RowData>" + sXMLData + "</RowData>"

    let oBusinessProcessStatelessUserAction = new BusinessProcessStatelessUserAction();
    oBusinessProcessStatelessUserAction.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessUserAction.lwfBusinessProcessStatelessActionId = lwfBusinessProcessStatelessActionId;
    oBusinessProcessStatelessUserAction.sXMLProcessStatelessData = sXMLData;


    let bServerCallRequired: boolean = false;

    for (let owfBusinessProcessStatelessActionExecute of oBusinessProcessStateLessActionDetails) {
      if (owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != null && owfBusinessProcessStatelessActionExecute.OpenFormWebUrl != '') {
        let sWebUrl: string = '';
        sWebUrl = owfBusinessProcessStatelessActionExecute.OpenFormWebUrl;

        //let i: number = 0;

        //while (i == 0) {
        //  let iLastIndexOpenBrace: number = 0;
        //  let iLastIndexCloseBrace: number = 0;

        //  iLastIndexOpenBrace = sWebUrl.lastIndexOf("[");
        //  iLastIndexCloseBrace = sWebUrl.lastIndexOf("]");

        //  if (iLastIndexOpenBrace > 0 && iLastIndexCloseBrace > 0) {
        //    if (iLastIndexOpenBrace < iLastIndexCloseBrace) {
        //      let sReplaceString: string = sWebUrl.substring(iLastIndexOpenBrace, (iLastIndexCloseBrace - iLastIndexOpenBrace + 1));

        //      let oReplaceDataValue = oRowData.find(x => x.ColumnName == sReplaceString.replace("[", "").replace("]", ""));

        //      if (sWebUrl.startsWith("mailto:")) {
        //        sWebUrl = sWebUrl.replace(sReplaceString, oReplaceDataValue.DataValue);
        //      }
        //      else {
        //        sWebUrl = sWebUrl.replace(sReplaceString, this.URLEncode(oReplaceDataValue));
        //      }
        //    }
        //  }
        //  else {
        //    i = 1;
        //  }
        //}

        this.__oBusinessProcessStateLessActionExecuteWebUrls.push(sWebUrl);



      }
      else {
        bServerCallRequired = true;
      }

    }

    if (bServerCallRequired) {
      if (this.__oStatelessGridSelectedKeys.length <= 0) {
        this.__bIsLoadingVisible = false;
        this.__oConfirmationComponent.show(ConfirmationType.Error, "Please select at least one row to proceed.", "Error", "Ok", "", false);
      } else {
        this.service.UpdateAllDataByPromise(oBusinessProcessStatelessUserAction, this.__sGetApiUrl + "api/WorkflowDashBoard/PostStatelessCommonUserAction").then(
          result => this.OnSuccessSaveStatelessCommon(result)
        ).
          catch(error => this.OnErrorStateless(error))
      }
    }
    else {
      this.__bIsLoadingVisible = false;
      for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
        window.open(oWebUrl, "_blank");
      }

    }
  }

  //On save success 
  public OnSuccessSaveStateless(response: any) {
    this.__bIsLoadingVisible = false;
    if (response != null) {
      var oResponse: string = response;

      if (oResponse == 'Success') {

        for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
          window.open(oWebUrl, "_blank");
        }
        this.__oStatelessGridFilters = this.__oDataGrid.instance.getVisibleColumns();
        this.__oStatelessGridSortings = this.__oDataGrid.instance.getVisibleColumns();
        this.RefreshGrid();
      }
      else {
        //let widgetOptions = {
        //  message: oResponse,
        //  closeOnClick: true
        //};
        // notify(widgetOptions, "error", 3000);
        let message: string = oResponse;
        let confirmationType: ConfirmationType = ConfirmationType.Error;
        let title: string = "Error";
        if (message.toLowerCase().startsWith("success:")) {
          title = 'Success';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Success;
        } else if (message.toLowerCase().startsWith("error:")) {
          title = 'Error';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Error;
        } else if (message.toLowerCase().startsWith("warning:")) {
          title = 'Warning';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Warning;
        } else if (message.toLowerCase().startsWith("information:")) {
          title = 'Information';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Information;
        }
        this.__oConfirmationComponent.show(confirmationType, message, title, "Ok", "", false);
      }
    }
  }

  //On action failure 
  public OnErrorStateless(error: any) {
    this.__bIsLoadingVisible = false;
    if (error != null) {
      //let widgetOptions = {
      //  message: error,
      //  closeOnClick: true
      //};
      //notify(widgetOptions, "error", 3000);

      this.__oConfirmationComponent.show(ConfirmationType.Error, error, "Error", "Ok", "", false);
    }
  }

  public OnSuccessSaveStatelessCommon(response: any) {
    this.__bIsLoadingVisible = false;
    if (response != null) {
      var oResponse: string = response;

      if (oResponse == 'Success' || oResponse.startsWith('Success')) {

        for (var oWebUrl of this.__oBusinessProcessStateLessActionExecuteWebUrls) {
          window.open(oWebUrl, "_blank");
        }
        this.__oStatelessGridFilters = this.__oDataGrid.instance.getCombinedFilter();
        this.__oStatelessGridSortings = this.__oDataGrid.instance.getVisibleColumns();
        if(oResponse.startsWith('Success:')) {
          let message = oResponse.substring(oResponse.indexOf(":") + 1);
          this.__oConfirmationComponent.show(ConfirmationType.Success, message, "Success", "Ok", "", false);
        }
        this.RefreshGrid();
      }
      else {
         let message: string = oResponse;
        let confirmationType: ConfirmationType = ConfirmationType.Error;
        let title: string = "Error";
        if (message.toLowerCase().startsWith("success:")) {
          title = 'Success';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Success;
        } else if (message.toLowerCase().startsWith("error:")) {
          title = 'Error';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Error;
        } else if (message.toLowerCase().startsWith("warning:")) {
          title = 'Warning';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Warning;
        } else if (message.toLowerCase().startsWith("information:")) {
          title = 'Information';
          message = oResponse.substring(oResponse.indexOf(":") + 1);
          confirmationType = ConfirmationType.Information;
        }
        this.__oConfirmationComponent.show(confirmationType, message, title, "Ok", "", false);
      }
    }
  }

  //State less test method
  TestStateLess(e: any, info: any) {
    let Value = this.__oStatelessGridSelectedKeys;
    alert(info.lTradingcounterpartyId);

  }

  //On ke press event handler for number box details
  onKeyPressNumberBoxSLDetail(e: any, BusinessProcessStateLessDefinitionDetail: any, RowNumber: any) {
    //let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    //if (oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {

    //let BusinessProcessStateLessDefinitionDetail = oBusinessProcessStatelessDataContext.BusinessProcessStateLessDefinitionDetails.find(x => x.ColumnName == ColumnName);

    //if (e.event.key != 'Backspace')
    {

      if (BusinessProcessStateLessDefinitionDetail.DataValue != null && BusinessProcessStateLessDefinitionDetail.DataValue != undefined) {
        if (e.event.key == 'm' || e.event.key == "M") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
        }
        else if (e.event.key == "b" || e.event.key == "B") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
        }
        else if (e.event.key == "k" || e.event.key == "K") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        }
        else if (e.event.key == "h" || e.event.key == "H") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
        }
        else if (e.event.key == "t" || e.event.key == "T") {
          BusinessProcessStateLessDefinitionDetail.DataValue = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
        }
      }
    }

    //}
    if ((e.event.key == 'Delete' || e.event.key == "Backspace")
      && !this.__oUtilityService.IsNullOrUndefined(e.event.target.value) && e.event.target.value.toString() == "0") {
      BusinessProcessStateLessDefinitionDetail.DataValue = null;
      if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
        this.__oStatelessGridSelectedKeys = [];
      }
      if (this.__oStatelessGridSelectedKeys.filter(x => x == RowNumber).length == 0)
        this.__oStatelessGridSelectedKeys.push(RowNumber);
    }

  }

  // Grid details column value change event handler
  StatelessGridDetailColumnValueChanged(e: any, header: any, ColumnName: any, event?: any, name?: any) {
    if(name) {
      name = event.value;
    }
    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == e).length == 0)
      this.__oStatelessGridSelectedKeys.push(e);

    this.GetStatelessDependantDataItemSourceDetailSection(e, ColumnName);
  }

  //Clear grid filter
  ClearFilter(e: any) {
    if (this.__oDataGrid != null && this.__oDataGrid != undefined) {
      this.__oDataGrid.instance.clearFilter();
    }
  }

  ClearSorting(e: any) {
    if (this.__oDataGrid != null && this.__oDataGrid != undefined) {
      this.__oDataGrid.instance.clearSorting();
    }
  }

  ExportToExcel(e: any) {
    if (this.__oDataGrid != null && this.__oDataGrid != undefined) {
      let selectionOnly: boolean = false;
      switch (e.itemData.name) {
        case "Export all data":
          selectionOnly = false;
          break;
        case "Export selected rows":
          selectionOnly = true;
          break;
        default:
      }

      this.onExporting({
        component: this.__oDataGrid.instance,
        selectedRowsOnly: selectionOnly
      });
    }
  }

  onExporting(e: any) {
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet('Sheet');
    const name = this.__sBusinessProcessName + '.xlsx'
    exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        selectedRowsOnly: e.selectedRowsOnly,
        customizeCell: (options: any) => {
          const exportedValue = options.excelCell?.value;
          if (typeof exportedValue === 'string') {
            options.excelCell.value = exportedValue.trim();
          }
        }
    }).then(function() {
        workbook.xlsx.writeBuffer()
            .then(function(buffer: BlobPart) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), name);
            });
    });
    e.cancel = true; 
  }

  //Add a new row to grid
  AddRow(e: any) {

    if (this.__oStatelessGridSelectedKeys.length == 1) {
      this.__oConfirmationComponent.show(ConfirmationType.Information, "Do you want to clone the selected row ?", "Confirmation", "Yes", "No").then((result) => {
        if (result) {
          this.fnCloneRow(e);
        }
        else {
          this.fnAddRow(e);
        }
      });
    }
    else {
      this.fnAddRow(e);
    }
    //}
  }

  fnAddRow(e: any) {
    let oDataCntext = new BusinessProcessStatelessDataContext();

    oDataCntext.RowNumber = this.__oBusinessProcessStatelessDataContext.length + 1;
    oDataCntext.RowStatus = 'New';
    oDataCntext.QueryResult = [];

    for (var oDCD of this.__oStatelessGridColumnDetail) {
      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oDCD.ColumnName;
      oDynamicQueryResult.ColumnType = oDCD.ColumnType;
      oDataCntext.QueryResult.push(oDynamicQueryResult);
    }


    oDataCntext.DataValue = [];
    oDataCntext.ItemSource = [];
    oDataCntext.MultiSelectedItems = [];
    oDataCntext.IsMultiSelectComboBox = [];
    oDataCntext.BusinessProcessStateLessDefinitionDetails = [];
    oDataCntext.Opened = [];
    oDataCntext.NumberFormat = [];
    oDataCntext.MinNum = [];
    oDataCntext.MaxNum = [];
    oDataCntext.TextSize = [];

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);
    oDataCntext.MultiSelectedItems.push([]);
    oDataCntext.IsMultiSelectComboBox.push(false);
    oDataCntext.Opened.push(false);
    oDataCntext.NumberFormat.push('#,##0.##');
    oDataCntext.MinNum.push(0);
    oDataCntext.MaxNum.push(99);
    oDataCntext.TextSize.push(5000);

    oDataCntext.DataValue.push('');
    oDataCntext.ItemSource.push([]);
    oDataCntext.MultiSelectedItems.push([]);
    oDataCntext.IsMultiSelectComboBox.push(false);
    oDataCntext.Opened.push(false);
    oDataCntext.NumberFormat.push('#,##0.##');
    oDataCntext.MinNum.push(0);
    oDataCntext.MaxNum.push(99);
    oDataCntext.TextSize.push(5000);

    for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      // Adding Datavalue                        

      let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

      if (oColumn.ColumnType.includes('Boolean')) {

        let bValue: boolean = false
        oDataCntext.DataValue.push(bValue);

      }
      else if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {


        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
          let bValue: boolean = false;
          oDataCntext.DataValue.push(bValue);

        }
        else if(oSDD.wfBusinessProcessStatelessInputType == 'Date'){
          oDataCntext.DataValue.push(null);
        }
        else {
          oDataCntext.DataValue.push(Number(0));
        }
      }
      else {


        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

          let bValue: boolean = false;
          oDataCntext.DataValue.push(bValue);

        }
        else if(oSDD.wfBusinessProcessStatelessInputType == 'Date'){
          oDataCntext.DataValue.push(null);
        }
        else {
          let oEmptyValue = '';
          oDataCntext.DataValue.push(oEmptyValue);
        }
      }

      // Adding Itemsource

      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

        let oIS;

        try {
          oIS = JSON.parse(oSDD.ItemSource);
        }
        catch {

          console.log(oSDD.ItemSource);
        }
        oIS = oIS.map(item => ({
          ...item,
          DisplayMember: item.DisplayMember.replace(/DooobleQuote/g, '"').replace(/BaccckSlash/g, '\\')
        }));

        oDataCntext.ItemSource.push(oIS);
      }
      else {

        let oItemSource = [];
        oDataCntext.ItemSource.push(oItemSource);
      }


      //Adding multiselected items

      let oMultiSelectedKeys = [];
      oDataCntext.MultiSelectedItems.push(oMultiSelectedKeys);

      //Adding opened boolean value

      oDataCntext.Opened.push(false);

      // Adding number format , min , max , Text size

      oDataCntext.NumberFormat.push(oSDD.FormatString);
      oDataCntext.MinNum.push(oSDD.Min);
      oDataCntext.MaxNum.push(oSDD.Max);
      oDataCntext.TextSize.push(oSDD.TextSize);

    }


    for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {
      let oBusinessProcessStateLessDefinitionDetail = Object.assign({}, oSDD);

      oBusinessProcessStateLessDefinitionDetail.ItemSource = [];

      if (oSDD.ItemSource != null && oSDD.ItemSource != '') {

        let oIS;

        try {
          oIS = JSON.parse(oSDD.ItemSource);
        }
        catch {
          console.log(oSDD.ItemSource);
        }
        oBusinessProcessStateLessDefinitionDetail.ItemSource = oIS;
      }


      let oColumn = this.__oStatelessGridColumnDetail.find(x => x.ColumnName == oSDD.ColumnName);

      if (oColumn.ColumnType.includes('Boolean')) {

        let bValue: boolean = false
        oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

      }

      if (oColumn.ColumnType.includes('Money') || oColumn.ColumnType.includes('Int') || oColumn.ColumnType.includes('Decimal') || oColumn.ColumnType.includes('Double') || oColumn.ColumnType.includes('Float') || oColumn.ColumnType.includes('short') || oColumn.ColumnType.includes('double') || oColumn.ColumnType.includes('decimal') || oColumn.ColumnType.includes('integer') || oColumn.ColumnType.includes('int') || oColumn.ColumnType.includes('long')) {

        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {
          let bValue: boolean = false;
          oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

        }
        else {
          oBusinessProcessStateLessDefinitionDetail.DataValue = Number(0);
        }

      }
      else {

        if (oSDD.wfBusinessProcessStatelessInputType == 'Check Box') {

          let bValue: boolean = false;
          oBusinessProcessStateLessDefinitionDetail.DataValue = bValue;

        }
        else {
          //oBusinessProcessStateLessDefinitionDetail.DataValue = oColumnValue;
        }
      }

      oBusinessProcessStateLessDefinitionDetail.MultiSelectedItems = [];
      oBusinessProcessStateLessDefinitionDetail.Opened = false;

      if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {
        oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType = 'NULL';
      }


      oDataCntext.BusinessProcessStateLessDefinitionDetails.push(oBusinessProcessStateLessDefinitionDetail);

    }

    let oStatelessAction: Action[] = [];

    for (var oBusinessProcessStateLessActionDetail of this.__oBusinessProcessStateLessActionDetail.filter(x => x.IsCommonAction == 0)) {
      if (oStatelessAction.find(x => x.Name == oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction) == null) {
        let oAction = new Action();
        oAction.ID = oBusinessProcessStateLessActionDetail.lwfBusinessProcessStatelessActionId;
        oAction.Name = oBusinessProcessStateLessActionDetail.wfBusinessProcessStatelessAction;
        oAction.Width = oAction.Name.length * 8;

        if (oAction.Width < 125)
          oAction.Width = 125;
        oStatelessAction.push(oAction);
      }
    }

    oDataCntext.Actions = oStatelessAction;

    this.__oBusinessProcessStatelessDataContext.unshift(oDataCntext);
    this.__oDataGrid.instance.refresh();

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == oDataCntext.RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(oDataCntext.RowNumber);
  }

  fnCloneRow(e: any) {
    let RowNumber: number = this.__oStatelessGridSelectedKeys[0];

    let oBusinessProcessStatelessDataContextExist: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oBusinessProcessStatelessDataContextNew: BusinessProcessStatelessDataContext = new BusinessProcessStatelessDataContext();

    oBusinessProcessStatelessDataContextNew = JSON.parse(JSON.stringify(oBusinessProcessStatelessDataContextExist));
    //oBusinessProcessStatelessDataContextNew = Object.assign(oBusinessProcessStatelessDataContextNew, oBusinessProcessStatelessDataContextExist);

    oBusinessProcessStatelessDataContextNew.RowNumber = this.__oBusinessProcessStatelessDataContext.length + 1;
    oBusinessProcessStatelessDataContextNew.RowStatus = 'New';

    this.__oBusinessProcessStatelessDataContext.unshift(oBusinessProcessStatelessDataContextNew);
    this.__oDataGrid.instance.refresh();

    if (this.__oStatelessGridSelectedKeys == null || this.__oStatelessGridSelectedKeys == undefined) {
      this.__oStatelessGridSelectedKeys = [];
    }

    if (this.__oStatelessGridSelectedKeys.filter(x => x == oBusinessProcessStatelessDataContextNew.RowNumber).length == 0)
      this.__oStatelessGridSelectedKeys.push(oBusinessProcessStatelessDataContextNew.RowNumber);

    for (let i = 0; i < oBusinessProcessStatelessDataContextNew.DataValue.length; i++) {
      this.GetStatelessDependantDataItemSource(oBusinessProcessStatelessDataContextNew.DataValue[i], oBusinessProcessStatelessDataContextNew.RowNumber, i);
    }

  }

  onRowPrepared(e: any) {
    if (e.rowType == "data" && this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As Details' && x.IsDisplay == 1).length == 0) {
      if (e.rowElement.querySelector(".dx-command-expand") != undefined && e.rowElement.querySelector(".dx-command-expand").firstChild.classList != undefined) {
        e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-closed");
        e.rowElement.querySelector(".dx-command-expand").firstChild.classList.remove("dx-datagrid-group-opened");
        e.rowElement.querySelector(".dx-command-expand").classList.remove("dx-datagrid-expand");
      }
    }
  }

  onCellPrepared(e: any) {
    if (e.rowType === "data" && e.data && e.column.dataField === "lTradingCategoryId" && e.data.lTradingCategoryId === 1) {
      e.cellElement.style.fontWeight = "bold";
    }

    if (e.rowType === "data" && e.data && e.column.dataField === "SELL" && e.data.SELL) {
      e.cellElement.style.color = "red";
    }

  }

  onCellClick(e: any) {
    if (e.rowType === "data" && e.data && e.columnIndex > 1 && (e.data.IsStaticDataLoaded == undefined || e.data.IsStaticDataLoaded == null)) {
      e.data.IsStaticDataLoaded = true;
      this.GetStatelessDependantDataItemSourceStatic(e.data.RowNumber, e.columnIndex);
      this.GetStatelessDependantDataItemSourceDetailSectionStatic(e.data.RowNumber, this.__oStatelessColumnDetail[e.columnIndex]);
    }
  }

  OpenReferenceDataURLStateLess(ColumnIndex: any, RowIndex: any, RowNumber: any) {
    // let oBusinessProcessInstanceCurrentStateData: BusinessProcessStateLessDefinitionDetail = this.__oBusinessProcessInstanceCurrentStateDatas.find(x => x.lBusinessProcessInstanceCurrentStateDataId == e);

    let oBusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let dataValue = oBusinessProcessStatelessDataContext.DataValue[ColumnIndex];

    let sInstance: string = dataValue;

    let sWebURL: string = this.__oSwitchPortal.UrlAngular; //UrlSilverLIght;

    //sWebURL = sWebURL.replace('RCPortalFrameWork.aspx', '');

    if (oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex] != null &&
      oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex].indexOf('EntityGroup') > 0) {

      let sDataTypeParameter: string = oBusinessProcessStatelessDataContext.DataTypeParameter[ColumnIndex];

      let EntityGroup: string = sDataTypeParameter.substring(sDataTypeParameter.indexOf('<EntityGroup>') + 13, sDataTypeParameter.indexOf('</EntityGroup>'));

      sInstance = this.URLEncode(dataValue);
      this.OpenEntityGroupInstance(sWebURL, EntityGroup, sInstance);
    }
    else { window.open(sInstance, "_blank"); }
  }

  OpenEntityGroupInstance(sWebURL: string, EntityGroup: string, sInstance: string) {
    if (EntityGroup != null && EntityGroup != '') {
      // sWebURL = sWebURL + "/wfDataCaptureFormSL.aspx?Form=" + EntityGroup + "&Name=" + sInstance;
      if (EntityGroup.toLocaleLowerCase().trim() == 'counterparty management') {
        sWebURL = sWebURL + "TradingCounterparty/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'cash collateral') {
        sWebURL = sWebURL + "CashManagement/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'credit support annex') {
        sWebURL = sWebURL + "CreditSupportAnnex/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'letter of credit') {
        sWebURL = sWebURL + "LetterOfCredit/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'credit insurance management') {
        sWebURL = sWebURL + "CreditInsurance/" + sInstance;
      }
      //else if (EntityGroup.toLocaleLowerCase().trim() == 'netting contract clause') {
      //  sWebURL = sWebURL + "NettingContractClause/" + sInstance;
      //}
      else if (EntityGroup.toLocaleLowerCase().trim() == 'parent counterparty guarantee') {
        sWebURL = sWebURL + "CustomerGuarantee/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'netting contract') {
        sWebURL = sWebURL + "TradeNettingContract/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'our entity management') {
        sWebURL = sWebURL + "OurEntityManagement/13/" + sInstance;
      }
      //Fb 28022 Workflow> Reference data> opening silverlight screen for Limit Management or Call Memo Entity Group
      else if (EntityGroup.toLocaleLowerCase().trim() == 'call memo') {
        sWebURL = sWebURL + "CallMemo/" + sInstance;
      }
      else if (EntityGroup.toLocaleLowerCase().trim() == 'limit management') {
        sWebURL = sWebURL + "CounterpartyManagement/9/CounterpartyLimits?tradingcounterparty=" + sInstance;
      }
      else {
        let silverlightURL = this.__oSwitchPortal.UrlSilverLIght.replace('RCPortalFrameWork.aspx', '');
        sWebURL = silverlightURL + "/wfDataCaptureFormSL.aspx?Form=" + EntityGroup + "&Name=" + sInstance;
      }
      window.open(sWebURL, "_blank");
    }
    else {
      window.open(sInstance, "_blank");
    }
  }

  GetStatelessDependantDataItemSource(columnValue: any, RowNumber: any, columnIndex: any) {

    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let sColumnName = this.__oStatelessColumnDetail[columnIndex];

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];
    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];


      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else if (oBusinessProcessStateLessGridDataContext.IsMultiSelectComboBox[iIndex] && oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iIndex]?.length > 0) { //Multiselect combo box
        oDataValue = oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iIndex];
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }
      let _sColumnValue = columnValue;
      if (columnValue instanceof Date) {
        _sColumnValue = columnValue.toString();
      }
      if (iIndex == columnIndex && _sColumnValue.length == 0) {
        oDataValue = "";
        oBusinessProcessStateLessGridDataContext.DataValue[iIndex] = oDataValue;
      }
      else if (iIndex == columnIndex && _sColumnValue.length > 0) {
        if (oBusinessProcessStateLessGridDataContext.IsMultiSelectComboBox[iIndex])
          oDataValue = _sColumnValue.join(",");
        else
          oDataValue = columnValue;
        oBusinessProcessStateLessGridDataContext.DataValue[iIndex] = oDataValue;
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = sColumnName;
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;


    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSource(result, RowNumber, columnIndex)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }

  GetStatelessDependantDataItemSourceDetailSection(RowNumber: any, ColumnName: any) {

    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let sColumnName = ColumnName;

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = sColumnName;
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;


    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSourceDetail(result, RowNumber, ColumnName)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }


  GetStatelessDependantDataItemSourceStatic(RowNumber: any, columnIndex: any) {

    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let sColumnName = this.__oStatelessColumnDetail[columnIndex];

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];
    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = 'Static';
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;

    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSource(result, RowNumber, columnIndex)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }

  GetStatelessDependantDataItemSourceDetailSectionStatic(RowNumber: any, ColumnName: any) {

    let lwfBusinessProcessDefinitionId = this.__iWfBusinessProcessDefinitionId;
    let sColumnName = ColumnName;

    let sXMLData: string = '';

    let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);

    let oRowData: DynamicQueryResult[] = [];

    let iIndex: number = 0;

    // Creating column array with value

    for (var oColumnDetail of this.__oStatelessColumnDetail) {
      let oColumnName = oColumnDetail;
      let oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];

      let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

      let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oColumnName);


      if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
        if (oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iIndex] != undefined) {
          oDataValue = this.datePipe.transform(oBusinessProcessStateLessGridDataContext.DataValue[iIndex], 'yyyy-MM-dd');
        }
      }
      else {
        oDataValue = oBusinessProcessStateLessGridDataContext.DataValue[iIndex];
      }

      let oDynamicQueryResult = new DynamicQueryResult();
      oDynamicQueryResult.ColumnName = oColumnName;
      oDynamicQueryResult.DataValue = oDataValue;

      oRowData.push(oDynamicQueryResult);

      iIndex += 1;

    }

    if (oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != null && oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails != undefined) {
      for (var oDetailColumn of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oQueryResult: DynamicQueryResult[] = oBusinessProcessStateLessGridDataContext.QueryResult;

        let sColumnInfo: DynamicQueryResult = oQueryResult.find(x => x.ColumnName == oDetailColumn.ColumnName);

        let oDynamicQueryResult = new DynamicQueryResult();
        let oDetailColumnDataValue;

        if (sColumnInfo != undefined && sColumnInfo.ColumnType.includes('Date')) {
          if (oDetailColumn.DataValue != null && oDetailColumn.DataValue != undefined) {
            oDetailColumnDataValue = this.datePipe.transform(oDetailColumn.DataValue, 'yyyy-MM-dd');
          }
        }
        else {
          if (oDetailColumn.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {

            if (oDetailColumn.MultiSelectedItems != null && oDetailColumn.MultiSelectedItems.length > 0) {
              oDetailColumnDataValue = oDetailColumn.MultiSelectedItems.join(',');
            }

          }
          else {
            oDetailColumnDataValue = oDetailColumn.DataValue;
          }
        }

        oDynamicQueryResult.ColumnName = oDetailColumn.ColumnName;
        oDynamicQueryResult.DataValue = oDetailColumnDataValue;

        oRowData.push(oDynamicQueryResult);
      }

    }

    for (var oOtherRowData of oBusinessProcessStateLessGridDataContext.QueryResult) {
      if (oRowData.find(x => x.ColumnName == oOtherRowData.ColumnName) == null) {
        let oDynamicQueryResult = new DynamicQueryResult();
        oDynamicQueryResult.ColumnName = oOtherRowData.ColumnName;

        if (oOtherRowData.DataValue != null && oOtherRowData.DataValue != undefined && oOtherRowData.DataValue != '') {
          let sValue: string = oOtherRowData.DataValue;

          if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
            oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
          }
          else {
            oDynamicQueryResult.DataValue = sValue.toString().replace(/DooobleQuote/g, '"');
          }
        }
        else {
          oDynamicQueryResult.DataValue = oOtherRowData.DataValue;
        }

        oRowData.push(oDynamicQueryResult);
      }
    }

    // Creating string stateless row data in XML format

    for (var oStatelessRowData of oRowData) {
      sXMLData += "<" + oStatelessRowData.ColumnName + ">";

      if (oStatelessRowData.DataValue != null && oStatelessRowData.DataValue != undefined && oStatelessRowData.DataValue != '') {
        let sValue: string = oStatelessRowData.DataValue;

        if (sValue.toString().toLowerCase() == 'true' || sValue.toString().toLowerCase() == 'false') {
          sXMLData += oStatelessRowData.DataValue;
        }
        else {
          sXMLData += sValue.toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;');
        }
      }
      else {
        sXMLData += oStatelessRowData.DataValue;
      }


      sXMLData += "</" + oStatelessRowData.ColumnName + ">";
    }

    let oBusinessProcessStatelessDependantDataItemSource = new BusinessProcessStatelessDependantDataItemSource();
    oBusinessProcessStatelessDependantDataItemSource.lwfBusinessProcessDefinitionId = lwfBusinessProcessDefinitionId;
    oBusinessProcessStatelessDependantDataItemSource.sColumnName = 'Static';
    oBusinessProcessStatelessDependantDataItemSource.sXMLProcessStatelessData = sXMLData;


    this.service.UpdateAllDataByPromise(oBusinessProcessStatelessDependantDataItemSource, this.__sGetApiUrl + "api/WorkflowDashBoard/GetStatelessDependantDataItemSource").then(
      result => this.OnSuccessGetStatelessDependantDataItemSourceDetail(result, RowNumber, ColumnName)
    ).
      catch(error => this.OnErrorGetStatelessDependantDataItemSource(error))

  }

  public OnErrorGetStatelessDependantDataItemSource(error: any) {
    console.log(error);
  }
  public OnSuccessGetStatelessDependantDataItemSource(response: any, RowNumber: any, columnIndex: any) {

    if (response != null) {

      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
      let iColumnIndex: number = 2;

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {


        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);

        if (oBusinessProcessStateLessDefinitionDetail != null) {

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {

              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }


            if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {
              if (oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] != undefined) {


                let oMultiselectItems: any[] = oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iColumnIndex];
                let oItemSource: any[] = oIS;
                let oMultiselectItemsNew: any[] = [];
                let sDataValue: String = '';

                oMultiselectItems.forEach(x => {

                  if (oItemSource.find(y => y.DisplayMember == x) != undefined) {

                    oMultiselectItemsNew.push(x);
                  }

                });

                sDataValue = oMultiselectItemsNew.join(',');

                oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] = sDataValue
                oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iColumnIndex] = oMultiselectItemsNew
              }
            }
            else if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == null) {

              let oItemSource: any[] = oIS;
              let oMultiselectItemsNew: any[] = [];
              let sDataValue: string = '';

              oItemSource.forEach(x => {
                oMultiselectItemsNew.push(x.DisplayMember);
              });

              sDataValue = oMultiselectItemsNew.join(',');

              oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] = sDataValue
              oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iColumnIndex] = oMultiselectItemsNew

            }
            else if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == 'Check Box') {
              let sDataValue = oIS[0]?.DisplayMember;
              let bValue = false;
              if (sDataValue != undefined && sDataValue.toLowerCase() == 'true') {
                bValue = true;
              }

              oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] = bValue
            }

            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oIS;
          }
          else {

            let oItemSource = [];
            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oItemSource;
          }



        }

        iColumnIndex += 1;


      }


      for (var oSDD of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);


        if (oBusinessProcessStateLessDefinitionDetail != null) {

          oSDD.ItemSource = [];

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {
              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            oSDD.ItemSource = oIS;
          }

          if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {
            if (oSDD.DataValue != null && oBusinessProcessStateLessGridDataContext.DataValue != undefined) {
              oSDD.DataValue = '';
              oSDD.MultiSelectedItems = [];
            }
          }

        }



      }

    }

  }

  public OnSuccessGetStatelessDependantDataItemSourceDetail(response: any, RowNumber: any, ColumnName: any) {

    if (response != null) {

      let oBusinessProcessStateLessGridDataContext: BusinessProcessStatelessDataContext = this.__oBusinessProcessStatelessDataContext.find(x => x.RowNumber == RowNumber);
      let iColumnIndex: number = 2;

      for (var oSDD of this.__oBusinessProcessStateLessDefinitionDetails.filter(x => x.DisplayArea == 'As DataGrid Column' && x.IsDisplay == 1).sort(x => x.DisplayOrder)) {


        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);

        if (oBusinessProcessStateLessDefinitionDetail != null) {

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {

              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }

            if (oBusinessProcessStateLessDefinitionDetail.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {
              if (oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] != null && oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] != undefined) {


                let oMultiselectItems: any[] = oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iColumnIndex];
                let oItemSource: any[] = oIS;
                let oMultiselectItemsNew: any[] = [];
                let sDataValue: String = '';

                oMultiselectItems.forEach(x => {

                  if (oItemSource.find(y => y.DisplayMember == x) != undefined) {

                    oMultiselectItemsNew.push(x);
                  }

                });

                sDataValue = oMultiselectItemsNew.join(',');

                oBusinessProcessStateLessGridDataContext.DataValue[iColumnIndex] = sDataValue
                oBusinessProcessStateLessGridDataContext.MultiSelectedItems[iColumnIndex] = oMultiselectItemsNew
              }
            }

            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oIS;
          }
          else {

            let oItemSource = [];
            oBusinessProcessStateLessGridDataContext.ItemSource[iColumnIndex] = oItemSource;
          }



        }

        iColumnIndex += 1;


      }


      for (var oSDD of oBusinessProcessStateLessGridDataContext.BusinessProcessStateLessDefinitionDetails) {

        let oBusinessProcessStateLessDefinitionDetail: BusinessProcessStateLessDefinitionDetail = response.find(x => x.lBusinessProcessStateLessDefinitionDetailId == oSDD.lBusinessProcessStateLessDefinitionDetailId);


        if (oBusinessProcessStateLessDefinitionDetail != null) {

          oSDD.ItemSource = [];

          if (oBusinessProcessStateLessDefinitionDetail.ItemSource != null && oBusinessProcessStateLessDefinitionDetail.ItemSource != '') {

            let oIS;

            try {
              oIS = JSON.parse(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            catch {
              console.log(oBusinessProcessStateLessDefinitionDetail.ItemSource);
            }
            oSDD.ItemSource = oIS;
          }


          if (oSDD.wfBusinessProcessStatelessInputType == 'Multi Select Combo Box') {
            if (oSDD.DataValue != null && oBusinessProcessStateLessGridDataContext.DataValue != undefined) {
              oSDD.DataValue = '';
              oSDD.MultiSelectedItems = [];
            }
          }

        }



      }

    }

  }
  OpenURLFromGridRow(ColumnIndex: any, RowNumber: any) {
    let oRowData = this.__oBusinessProcessStatelessDataContext.find(x=>x.RowNumber == RowNumber);
    let parser = new DOMParser();
    let xml = parser.parseFromString(oRowData.DataTypeParameter[ColumnIndex],"text/xml")
    let sReferenceColumnName = xml.getElementsByTagName('Reference')[0].innerHTML;
    let bInNewTab = xml.getElementsByTagName('InNewTab').length > 0 ? true : false;

    let link = this.__oBusinessProcessStatelessQueryResult.find(x=>x.RowNumber === RowNumber).QueryResult.find(x=>x.ColumnName === sReferenceColumnName);
    if (link != null) {
      if(bInNewTab){
        window.open(link.DataValue,'_blank');
      }
      else{
        window.open(link.DataValue,'_self');
      }
    }
  }
}
